import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import LanguageDetector from 'i18next-browser-languagedetector'
import Backend from 'i18next-http-backend'

// Importa le traduzioni staticamente per il caricamento sincrono
import itTranslations from '../locales/it/common.json'
import enTranslations from '../locales/en/common.json'

export const supportedLanguages = ['it', 'en'] as const
export type SupportedLanguage = (typeof supportedLanguages)[number]
export const defaultLanguage: SupportedLanguage = 'it'

// Risorse per caricamento sincrono (utile per test e SSR)
const resources = {
  it: { common: itTranslations },
  en: { common: enTranslations },
}

i18n
  .use(Backend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: defaultLanguage,
    supportedLngs: supportedLanguages,
    debug: import.meta.env.DEV,

    interpolation: {
      escapeValue: false,
    },

    backend: {
      loadPath: '/locales/{{lng}}/{{ns}}.json',
    },

    detection: {
      order: ['path', 'localStorage', 'navigator'],
      lookupFromPathIndex: 0,
      caches: ['localStorage'],
    },

    react: {
      useSuspense: true,
    },

    ns: ['common'],
    defaultNS: 'common',
    
    // Caricamento sincrono delle risorse
    resources,
  })

export default i18n
